import React, {
  FC,
  PropsWithChildren,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react'

import { css, cx } from '@linaria/core'
import { useLocation } from 'react-router-dom'

import { WithClassName } from 'common/types'
import { useResizeObserver } from 'hooks/useResizeObserver'

type position = 'top' | 'bottom'

/**
 * TODO: пока оставил так, возможно на будущее надо будет переделать для того чтобы снаружи передавать стили
 */
export const StickyObserver: FC<
  PropsWithChildren &
    WithClassName & { isDisabledEventScroll?: boolean; position?: position }
> = ({
  children,
  className,
  isDisabledEventScroll = false,
  position = 'top',
}) => {
  const stickyRef = useRef<HTMLDivElement | null>(null)
  const [isActive, setIsActive] = useState(false)
  const pathname = useLocation()
  const parent = useRef<HTMLElement | null>(null)

  const handleScroll = useCallback(() => {
    const element = stickyRef.current
    if (!element) return

    if (isDisabledEventScroll) {
      setIsActive(false)
      return
    }

    if (position === 'top') {
      if (window.scrollY > 0) {
        setIsActive(true)
      } else {
        setIsActive(false)
      }
    } else if (position === 'bottom') {
      if (
        document.documentElement.scrollHeight - window.scrollY <=
        document.documentElement.offsetHeight
      ) {
        setIsActive(false)
      } else {
        setIsActive(true)
      }
    }
  }, [isDisabledEventScroll, position])

  useResizeObserver(parent, handleScroll)

  useEffect(() => {
    // Проверяем положение элемента сразу при монтировании
    setIsActive(false)
    handleScroll()
  }, [handleScroll, pathname])

  /**
   * Пока так
   * 1. window.resize не реагирует из-за height:100% в src/common/components/designSystem/shared/globalCss.ts:8
   * 2. Поэтому завязался на изменение высоты блока внутри
   */
  useEffect(() => {
    /** TODO: не нравится, надо бы переделать */
    parent.current = document.getElementById('app-wrapper')

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [position, handleScroll])

  return (
    <div
      ref={stickyRef}
      className={cx(className, isActive && borderActive[position])}
    >
      {children}
    </div>
  )
}

const borderActive: Record<position, ReturnType<typeof css>> = {
  top: css`
    box-shadow: inset 0 -1px var(--border-muted);
  `,
  bottom: css`
    box-shadow: inset 0 1px var(--border-muted);
  `,
}
